import ReporteBase from "./ReportePage.js";

const ReporteCotizacionBloqueada = () => {
    return (
        <ReporteBase
            titulo="Cotizaciones Bloqueadas"
            variant="BLOQUEADA"
        />
    );
};

export default ReporteCotizacionBloqueada;